import { Component, OnInit } from '@angular/core';
import { UserUtilService } from 'src/app/core/services/common/user-util.service';

@Component({
  selector: 'app-trainings',
  templateUrl: './trainings.component.html',
  styleUrls: ['./trainings.component.scss']
})
export class TrainingsComponent implements OnInit {

  constructor(public userUtilsService:UserUtilService) { }

  ngOnInit(): void {
  }

}
